/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedDocumentAdmin } from './PaginatedDocumentAdmin'
import {
  PaginatedDocumentAdminFromJSON,
  PaginatedDocumentAdminFromJSONTyped,
  PaginatedDocumentAdminToJSON,
} from './PaginatedDocumentAdmin'

/**
 *
 * @export
 * @interface EnvelopedDocumentListDocumentAdmin
 */
export interface EnvelopedDocumentListDocumentAdmin {
  /**
   *
   * @type {PaginatedDocumentAdmin}
   * @memberof EnvelopedDocumentListDocumentAdmin
   */
  body: PaginatedDocumentAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedDocumentListDocumentAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedDocumentListDocumentAdmin interface.
 */
export function instanceOfEnvelopedDocumentListDocumentAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedDocumentListDocumentAdminFromJSON(
  json: any,
): EnvelopedDocumentListDocumentAdmin {
  return EnvelopedDocumentListDocumentAdminFromJSONTyped(json, false)
}

export function EnvelopedDocumentListDocumentAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedDocumentListDocumentAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedDocumentAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedDocumentListDocumentAdminToJSON(
  value?: EnvelopedDocumentListDocumentAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedDocumentAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
